import React, { useEffect, useState } from 'react';
import { BaSeInput } from '@base/react';
import styled from "styled-components";

const SearchInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  input {
    border-radius: 50px;
    background-color: #f8f8f8;
    border: 0;
  }
`;

export const SearchInputAdmin = ({
  value = '',
  iconColor = '#0061C6',
  placeholder = 'Digite o que você procura...',
  onChange = () => {},
}) => {

  const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

  return (
    <SearchInputContainer>
      <BaSeInput
        label={null}
        iconButton={{
         action: () => onChange(inputValue),
          name: 'search',
          type: 'primary-default',
          typeButton: 'base-icon',
          value: 'Default',
          color: iconColor,
        }}
        value={inputValue}
        onChange={setInputValue}
        placeholder={placeholder}
        size="big"
        typeInput="text"
        width="100%"
      />
    </SearchInputContainer>
  );
};
